import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Route } from 'react-router-dom';
import { ConnectedRouter } from 'react-router-redux';
import firebase from 'firebase';

import history from './lib/history';
import { logoutUser } from 'services/auth/actions';
import { addEntries } from 'data/actions';
import { openModalWithEntries } from 'scenes/EntriesAddModal/actions';
import NavHeader from 'components/NavHeader/index';
import Footer from 'components/Footer';

import Main from './scenes/Main';
import Login from './scenes/Login';
import FaqPage from './scenes/FAQ';
import PrivacyPage from './scenes/Privacy';
import { LandingPage, ConfirmationPage } from './scenes/LandingFlow';
// import Confirmation from 'scenes/LandingFlow/ConfirmationPage';
import EntriesAddModal from './scenes/EntriesAddModal';
import ThemingLayout from './scenes/Themes';

import ModalSwitch from 'components/ModalSwitch';
import PrivateRoute from './containers/PrivateRoute';
import LoggedOutRoute from './containers/LoggedOutRoute';
import { msgs } from 'extension/src/messages';
import { makeDebugger } from 'lib';

const debug = makeDebugger('Root');

class Root extends Component {
  constructor(props) {
    super(props);
    this.msgHandler = this.msgHandler.bind(this);
  }

  componentDidMount() {
    window.addEventListener('message', this.msgHandler);
  }

  componentWillUnmount() {
    window.removeEventListener('message', this.msgHandler);
  }

  verifyDataFormat(data) {
    for (let obj of data) {
      if (!obj.url) return false;
      if (!obj.title) return false;
    }
    return true;
  }

  msgHandler(e) {
    debug("received message", e.data);
    if (e.origin !== window.location.origin) return;
    if (e.data.type === msgs.STATUS_REQUEST) {
      this.sendStatus();
    } else if (e.data.type === msgs.TABS_POST) {
      // TODO: verify data format
      const tabsToAdd = e.data.value;
      debug("to add tabs: ", tabsToAdd);
      if (this.verifyDataFormat(tabsToAdd)) {
        // this.props.addEntries(tabsToAdd);
        debug("setting open modal")
        this.props.openModal(tabsToAdd);
        window.postMessage({ type: msgs.TABS_POST_SUCCESS }, window.location.origin);
      }
    }
  }

  sendStatus(loggingOut) {
    const data = {
      type: msgs.STATUS_RESPONSE,
      value: firebase.auth().currentUser && !loggingOut ? msgs.STATUS_READY : ''
    }
    window.postMessage(data, window.location.origin);
  }

  componentDidUpdate(prevProps) {
    const isLoggingOut = prevProps.isAuthed && !this.props.isAuthed
    const isLoggingIn = !prevProps.isAuthed && this.props.isAuthed

    if (isLoggingIn) {
      // TODO: could be where to load in all the data and listeners?
      this.sendStatus();
    } else if (isLoggingOut) {
      // TODO: Could be where I should unwatch all listeners
      this.sendStatus(true);
    }
  }

  render() {
    return(
      <ConnectedRouter history={history}>
        {/* Why do I have this container??? */}
        <div className='app-container'>
          <NavHeader
            logoutUser={this.props.logoutUser}
            activeItem={history.location.pathname}
            isAuthed={this.props.isAuthed} />
          {/* ROUTES */}
          <LoggedOutRoute exact path='/' component={LandingPage}/>
          <LoggedOutRoute path='/confirmation' component={ConfirmationPage}/>
          <LoggedOutRoute path='/login' component={Login}/>
          <Route path='/theme' component={ThemingLayout}/>
          <Route path='/faq' component={FaqPage}/>
          <Route path='/privacy' component={PrivacyPage}/>
          {/* If no current user, redirect to / */}
          <Route children={({ ...rest, history }) => (
            <ModalSwitch
              {...rest}
              history={history}
              modalPath="/entries/add"
              modal={EntriesAddModal}
              routes={[
                {type: PrivateRoute, component: Main, path: '/app'}
              ]}/>
            )}/>
          {/* FOOTER */}
          <Footer isAuthed={this.props.isAuthed} />
        </div>
      </ConnectedRouter>
    );
  }
}

const mapStateToProps = ({ auth }) => {
  return {
    isAuthed: auth.isAuthed
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    addEntries: (entries) => { dispatch(addEntries(entries)) },
    logoutUser: () => { dispatch(logoutUser()) },
    openModal: (entries) => { dispatch(openModalWithEntries(entries)) }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Root);



// WEBPACK FOOTER //
// ./src/Root.js